import { ReactNode } from "react";
import { ConditionalProtectedRoute } from "./ConditionalProtectedRoute";
import { ConditionalMainLayout } from "./ConditionalMainLayout";

export interface RouteElementProps {
  isProtected: boolean;
  children: ReactNode;
  hideMainLayout: boolean;
  useDefaultTitle?: boolean;
}

export const RouteElement = ({ isProtected, children, hideMainLayout, useDefaultTitle }: RouteElementProps) => {
  return (
    <ConditionalProtectedRoute isProtected={isProtected}>
      <ConditionalMainLayout hideMainLayout={hideMainLayout} useDefaultTitle={useDefaultTitle}>
        {children}
      </ConditionalMainLayout>
    </ConditionalProtectedRoute>
  );
};
